<template>
  <div class="contenter index-contenter">
    <span class="logo"></span>
    <div class="content">
      <a-button-group class="button-group" size="large">
        <a-select v-model="selectSearch" size="large" style="width:200px">
          <a-select-option v-for="(v,k) in search.map(m=>m.type)" :key="k" :value="k">{{v}}</a-select-option>
        </a-select>
        <a-input
          size="large"
          v-model="searchCond"
          :placeholder="`请输入${search[selectSearch]['input']}`"
          @pressEnter="searchHandle"
        />
        <a-button type="primary" style="width:120px;" @click="searchHandle">搜索</a-button>
      </a-button-group>
    </div>
    <span class="end"></span>
  </div>
</template>
<script>
import DemoVideo from "./DemoVideo";
import Updatelog from './UpdateLog.vue'
export default {
  data() {
    return {
      searchCond: "",
      selectSearch: 0,
      search: [
        { type: "国外采购商", input: "采购商名称", name: "buyerfinder" },
        { type: "采购产品名称", input: "采购产品名称", name: "buyerfinder" },
        { type: "国外展会名录", input: "公司名称", name: "buyerfinder" },
        { type: "国际展会", input: "展会名称", name: "buyerfinder" }
      ]
    };
  },
  created() {
    this.getcode();
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  methods: {
    getcode() {
      const code = this.$route.query.code;
      if (typeof code != "undefined") {
        this.$http
          .post("/zzWechatLogin", {
            code: code
          })
          .then(res => {
            console.log(res);
            if (res.error == 0) {
              this.$cookies.remove("hideRechargeTip", "/");
              this.$cookies.set("access-token", res.data.token, "7d", "/");
              location.href = "/";
            }
            if (res.error == 1) {
              this.$cookies.set("u", res.unionid, 0, "/");
              this.$loginFrm2();
            }
            if (res.error == 2) {
              location.href = "/";
            }
          });
      }else{
        this.getVersion();
      }
    },
    playVideo(type) {
      this.$dialog(DemoVideo, {
        url: { keyperson: "http://video.showguide.cn/pc1.mp4" }[type]
      });
    },
    searchHandle() {
      if (!this.searchCond) {
        this.$message.error(`请输入${this.search[this.selectSearch]["input"]}`);
        return;
      }

      this.$router.push({
        path: `/${this.search[this.selectSearch]["name"]}?st=${
          this.selectSearch
        }&search=${this.searchCond}`
      });
    },
    getVersion(){
      this.$http.post('/zzVersionList').then(m=>{
        console.log(m)
        if(m.error===0&&!!m.list&&m.list.length>0){
          let version=m.list&&m.list.length&&m.list[0];
          console.log(version)
          let id=this.$getStore('version_id')
          if((version&&version.id||'')!=id){
            this.$dialog(Updatelog,{version});
          }
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/components/layout/style/mixin.scss";
.index-contenter {
  background: url("~@/assets/img/zz360index.jpg") no-repeat center -200px;
  min-height: 890px;
  background-color: #011621;
  .logo {
    position: absolute;
    display: inline-block;
    width: 200px;
    height: 70px;
    @include intop-icon;
    background-position: -40px -400px !important;
    margin: 15px 0 0 10px;
  }
  .end {
    width: 1043px;
    height: 60px;
    background: url("~@/assets/img/zz360index_end.png") no-repeat center;
    margin: 30px auto;
  }
  .content {
    flex: none;
    margin: auto;
    height: 700px;
    background: url("~@/assets/img/zz360index_title.png") no-repeat center;
    .button-group {
      color: #333;
      margin-top: 270px;
      & > div,
      & > input,
      & > button {
        vertical-align: middle;
      }

      & /deep/ .ant-select:not(.ant-select-open) {
        .ant-select-selection {
          border-right: 0;
        }
      }

      input {
        width: 670px;
        border-right: none;
        border-color: #d4d4d4;
        border-width: 2px;
      }
      & /deep/ .ant-btn {
        border: none;
      }
      & /deep/ .ant-select,
      & /deep/ .ant-select-selection,
      & /deep/ .ant-btn,
      & /deep/ .ant-input {
        border-radius: 0 !important;
        border-color: #1890ff;
        margin-right: 0;
        border-width: 2px;
      }
    }
  }
}
@media screen and (max-height: 800px) {
  .index-contenter {
    background: url("~@/assets/img/zz360index.jpg") no-repeat center;
    min-height: 800px;
    background-size: 100% 100%;
    .end {
      background-size: 86% auto;
      position: relative;
      top: 90px;
    }
    .content {
      margin: 0px auto;
      max-height: 600px;
      background: url("~@/assets/img/zz360index_title.png") no-repeat center;
      background-size: 100% auto;
      .button-group {
        color: #333;
        position: relative;
        top: -14px;
        & > div,
        & > input,
        & > button {
          vertical-align: middle;
        }

        & /deep/ .ant-select:not(.ant-select-open) {
          .ant-select-selection {
            border-right: 0;
          }
        }

        input {
          width: 400px;
        }
      }
    }
  }
}
@media screen and (min-height: 800px) {
  .index-contenter {
    .content {
      .button-group {
        & /deep/ .ant-select-selection,
        .ant-input,
        .ant-btn-primary{
          height:60px;
          font-size:16px;
        }
        & /deep/ .ant-select-lg .ant-select-selection__rendered{
          line-height:58px;
          font-size:16px;
        }
      }
    }
  }
}
</style>